import React from 'react';
import { Container, Flex, Image, Link } from '@chakra-ui/react';
import { useColorMode } from '@chakra-ui/react';
import { Link as ReachLink } from 'react-router-dom';

import logo from '../../../assets/images/logo.svg';
import logoDark from '../../../assets/images/logo-dark.svg';

function Navbar() {
  const { colorMode } = useColorMode();

  return (
    <Container maxW='container.xl'>
      <Flex alignItems='center' height='20'>
        <Link as={ReachLink} to='/'>
          <Image
            h='10'
            src={colorMode === 'light' ? logo : logoDark}
            alt='ppi sakarya logo'
          />
        </Link>
      </Flex>
    </Container>
  );
}

export default Navbar;
